import { render, staticRenderFns } from "./CurriculumDetails.vue?vue&type=template&id=61fbe5f0&scoped=true&"
import script from "./CurriculumDetails.vue?vue&type=script&lang=js&"
export * from "./CurriculumDetails.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumDetails.vue?vue&type=style&index=0&id=61fbe5f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbe5f0",
  null
  
)

export default component.exports